export default __webpack_public_path__ + "static/2021Icon-310880836d1fa1830a60a27f25021659.png";